interface AuthOverlayProps {
	message?: string;
}

/**
 * Full-screen branded loading overlay shown while the backend SSO
 * exchange is in progress after a Microsoft redirect. Blocks all
 * interaction and communicates progress clearly to the user.
 */
export const AuthOverlay = ({
	message = "Verifying your account…",
}: AuthOverlayProps) => {
	return (
		<output
			aria-label={message}
			aria-live="polite"
			className="fixed inset-0 z-[9998] flex flex-col items-center justify-center bg-white/90 backdrop-blur-sm"
		>
			{/* Spinner */}
			<div className="relative mb-6">
				{/* Outer ring */}
				<div className="h-16 w-16 rounded-full border-4 border-gray-100" />
				{/* Spinning arc */}
				<div className="absolute inset-0 h-16 w-16 animate-spin rounded-full border-4 border-transparent border-t-accent" />
			</div>

			<div className="mb-5 text-xl font-bold tracking-tight text-primary">
				Kerzner Residences
			</div>

			{/* Status message */}
			<p className="text-sm text-body">{message}</p>

			{/* Animated dots for living feel */}
			<div className="mt-3 flex gap-1.5">
				{[0, 1, 2].map((i) => (
					<span
						key={i}
						className="h-1.5 w-1.5 rounded-full bg-accent opacity-0 animate-[pulse_1.2s_ease-in-out_infinite]"
						style={{ animationDelay: `${i * 0.2}s` }}
					/>
				))}
			</div>
		</output>
	);
};
